import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { LibraryService } from '@app/services/app/library.service';

import * as Objects from '@core/objects';
import { AccessVersionStatus, AccessVersionKeys } from '@app/models/access';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';

@Component({
  selector: 'version-helper-three-dot-status-update-menu',
  templateUrl: './three-dot-status-update-menu.component.html',
  styleUrls: ['./three-dot-status-update-menu.component.scss']
})
export class VersionHelperThreeDotStatusUpdateMenuComponent implements OnInit, OnDestroy {

  @Input() menu: Array<ThreeDotsMenuItem> = [];
  @Input() version: Objects.Version = null;

  @Output() action = new EventEmitter<string>();
  @Output() actionStatus = new EventEmitter<Objects.Status>();

  public open: boolean = false;
  public statusOpen: boolean = false;

  private wasInside: boolean = false;

  // public versionAccess: AccessVersion = null;
  public versionStatusUpdateAccess: boolean = false;
  public futureStatus: Array<Objects.Status> = [];
  public allVersionStatus: Array<Objects.Status> = null;
  public allowedVersionStatus: Array<Objects.Status> = [];

  protected statusSubscriptor: Subscription;
  protected accessVersionSubscriptor: Subscription;
  protected docClickSusbs: Subscription;

  constructor(
    private librarySrv: LibraryService,
    private iListenerSrv: InterfaceListenerService
  ) { }

  ngOnInit() {

    this.docClickSusbs = this.iListenerSrv.getDocuementClicked$().subscribe((value: any ) => {
      // this listen all clicks in the document, so we need to check what was ours
      if(this.open && !this.wasInside){
          this.open = false;
      } else {
          this.wasInside = false;
      }
    });

    if(this.version != null ){ 
      // get access from the library store. 
      this.accessVersionSubscriptor = this.librarySrv.selectVersionStatusAccess(this.version.status.id).subscribe((AccessVS: AccessVersionStatus) => {
          if(AccessVS != null ){

            this.allVersionStatus = AccessVS.access.status;
            this.versionStatusUpdateAccess = AccessVS.access.grants[AccessVersionKeys.CHANGE_STATUS] || false;
            this.updateAllowedStatus();
          }
      });
    }

   
  }

  ngOnDestroy(): void {
    this.docClickSusbs.unsubscribe();
    if(this.accessVersionSubscriptor)
      this.accessVersionSubscriptor.unsubscribe();
    if(this.statusSubscriptor)
      this.statusSubscriptor.unsubscribe();
    
  }

  // this is the only click inside to open the menu,  
  toggleMenu() : void {
    this.open = !this.open;
    this.wasInside = true;
  }

  toggleStatus() : void {
    this.statusOpen = !this.statusOpen;
    this.wasInside = true
  }

  onMenuClick(key: string) : void {
    // console.log(" version status 3 dot menu item click"+key)
    this.wasInside = false;
    this.action.emit(key);
  }


  onStatusMenuSelect(status: Objects.Status) : void{
    // use the the parent store to update status
    this.actionStatus.emit(status);
    this.toggleStatus();
    this.open = !this.open;
    this.wasInside = false;
  }


  protected updateAllowedStatus(){
    if(this.allVersionStatus != null && this.versionStatusUpdateAccess != null){
        this.allowedVersionStatus = this.versionStatusUpdateAccess ? this.allVersionStatus.filter((s: Objects.Status) => s.id != this.version.status.id) : [];
    }
    
}


}
